import React, { FC } from "react";
import { faInfoCircle, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
    title: string;
    infoText?: string;
    className?: string;
    titleClassName?: string;
    variant?: "info" | "warning";
};

const SectionHeader: FC<Props> = ({
    title,
    infoText,
    className = "",
    titleClassName = "mb-3 text-portal-blue-primary-shade2 text-xl font-semibold",
    variant = "info",
}) => {
    const icon = variant === "warning" ? faTriangleExclamation : faInfoCircle;
    const iconClass = variant === 'warning' ? 'text-orange-600 flex-shrink-0 mt-0.5' : 'text-blue-500 flex-shrink-0 mt-0.5';

    return (
        <div className={className}>
            <div className={titleClassName}>{title}</div>
            {infoText ? (
                <div className="flex items-start gap-2 mb-3 text-sm text-slate-700">
                    <FontAwesomeIcon icon={icon} className={iconClass} />
                    <span>{infoText}</span>
                </div>
            ) : null}
        </div>
    );
};

export default SectionHeader;